const CONSTANTS = {
  STORAGE_KEY: {
    DRIVER_USER: 'driver-user',
    REDIRECT: 'redirect',
    LOGIN_INFO: 'login-info',
    PRICE_QUOTE_DISMISS: 'price-quote-dismiss',
    INSTANT_DISMISS: 'instant-dismiss',
  },
  DATE_FORMAT: {
    LONG: 'DD/MM/YYYY HH:mm:ss',
    TIME: 'HH:mm:ss',
    SHORT: 'DD/MM/YYYY',
    TIMEZONE: 'Asia/Ho_Chi_Minh',
  },
  TIME_FORMAT: 'HH:mm:ss',
  TIME_FORMAT_SHORT: 'HH:mm',
  SYSTEM_ROLES: {
    QUAN_TRI_HE_THONG: 'QUẢN TRỊ HỆ THỐNG',
    KHOA_THANH_TOAN_KHI_NHAN_TIEN_DE_XUAT_HOA_DON: 'KHÓA THANH TOÁN KHI NHẬN TIỀN ĐỂ XUẤT HÓA ĐƠN TRƯỚC',
    BAM_THANH_TOAN_CUA_VAN_HANH_DON_HANG: 'BẤM THANH TOÁN CỦA VẬN HÀNH ĐƠN HÀNG',
    QUAN_LY_GIO_CONG: 'QUẢN LÝ GIỜ CÔNG',
    BAO_MAT_TAI_XE_CHU_HANG: 'BẢO MẬT TÀI XẾ, CHỦ HÀNG',
    XEM_NOI_DUNG_CHINH_SUA_DON_HANG: 'XEM NỘI DUNG CHỈNH SỬA ĐƠN HÀNG',
    TAM_DUNG_DON_HANG: 'TẠM DỪNG ĐƠN HÀNG',
    CAI_DAT_KHAI_THAC_KHACH_HANG: 'CÀI ĐẶT KHAI THÁC KHÁCH HÀNG',
    CAI_DAT_KHAO_SAT_NHAN_VIEN: 'CÀI ĐẶT KHẢO SÁT NHÂN VIÊN',
    CAI_DAT_PHAN_QUYEN: 'CÀI ĐẶT PHÂN QUYỀN',
    NHAP_VAY_TIEN: 'NHẬP VAY TIỀN',
    CAI_DAT_HAN_MUC_CONG_NO: 'CÀI ĐẶT - HẠN MỨC CÔNG NỢ',
    CAI_DAT_TI_LE_HAN_MUC_CONG_NO: 'CÀI ĐẶT TỶ LỆ - HẠN MỨC CÔNG NỢ',
  },
  CHAT_ROLES: {
    QUAN_LY_NHOM_CHAT_NOI_BO: 'QUẢN LÝ NHÓM CHAT NỘI BỘ',
  },
  STAFF_ROLES: {
    DS_TAI_XE: 'DS TÀI XẾ',
    XE_DAT_HANG: 'XE ĐẶT HÀNG',
    DS_CHU_HANG: 'DS CHỦ HÀNG',
    CHU_DAT_HANG: 'CHỦ ĐẶT HÀNG',
    DS_CHANH_XE: 'DS CHÀNH XE',
    CHANH_DAT_HANG: 'CHÀNH ĐẶT HÀNG',
    VAN_HANH_DON_HANG: 'VẬN HÀNH ĐƠN HÀNG',
    CHINH_SUA_HOP_DONG_DON_HANG: 'CHỈNH SỬA HỢP ĐỒNG ĐƠN HÀNG',
    LAM_LENH_THANH_TOAN_CHUYEN_KHOAN: 'LÀM LỆNH THANH TOÁN CHUYỂN KHOẢN',
    DS_BAO_HIEM: 'DS BẢO HIỂM',
    DON_HANG_BAO_HIEM: 'ĐƠN HÀNG BẢO HIỂM',
  },
  APP_ROLES: {
    TRUY_CAP_APP_TAI_XE: 'TRUY CẬP APP TÀI XẾ',
    TRUY_CAP_APP_CHU_HANG: 'TRUY CẬP APP CHỦ HÀNG',
  },
  PPKD_ROLES: {
    DON_HANG_NHANH: 'ĐƠN HÀNG NHANH',
    PHAN_VIEC_TAI_XE: 'PHÂN VIỆC TÀI XẾ',
    PHAN_VIEC_CHU_HANG: 'PHÂN VIỆC CHỦ HÀNG',
    XEM_THONG_KE_CUOC_GOI: 'XEM THỐNG KÊ CUỘC GỌI',
  },
  MANAGEMENT_ROLES: {
    CHINH_SUA_DU_LIEU_SAU_KHI_VAN_HANH_DON_HANG: 'CHỈNH SỬA DỮ LIỆU SAU KHI VẬN HÀNH ĐƠN HÀNG',
    DUA_SDT_NHAN_VIEN_LEN_TREN_APP: 'ĐƯA SĐT NHÂN VIÊN LÊN TRÊN APP',
    XEM_THONG_TIN_DAY_DU_KHI_VAN_HANH_DON_HANG: 'XEM THÔNG TIN ĐẦY ĐỦ KHI VẬN HÀNH ĐƠN HÀNG',
    BAM_NUT_VAN_CHUYEN_DON_HANG_TREN_VAN_HANH_DON_HANG: 'BẤM NÚT VẬN CHUYỂN ĐƠN HÀNG TRÊN VẬN HÀNH ĐƠN HÀNG',
    CHINH_SUA_THONG_TIN_TAI_XE: 'CHỈNH SỬA THÔNG TIN TÀI XẾ',
    CHINH_SUA_THONG_TIN_CHU_HANG: 'CHỈNH SỬA THÔNG TIN CHỦ HÀNG',
    DUYET_HUY_TUONG_TAC_TAI_XE: 'DUYỆT HỦY TƯƠNG TÁC TÀI XẾ',
    CHINH_SUA_MA_GIOI_THIEU_PHAN_TAI_XE: 'CHỈNH SỬA MÃ GIỚI THIỆU PHẦN TÀI XẾ',
    XEM_MA_CHEO_CHU_HANG_VA_TAI_XE: 'XEM MÃ CHÉO CHỦ HÀNG VÀ TÀI XẾ',
    QUAN_LY_FILE: 'QUẢN LÝ FILE',
    XEM_TAT_CA_DON_XE_DAT_HANG: 'XEM TẤT CẢ ĐƠN XE ĐẶT HÀNG',
    CAI_DAT_PHAN_DON: 'CÀI ĐẶT PHÂN ĐƠN',
    XEM_BAO_GIA_DON_HANG_NHANH: 'XEM BÁO GIÁ ĐƠN HÀNG NHANH',
    MO_VAN_HANH_NHIEU_DON: 'MỞ VẬN HÀNH NHIỀU ĐƠN',
  },
  INSURANCE_ROLES: {
    CAI_DAT_NGAY_GAN_HET_HAN_BAO_HIEM: 'CÀI ĐẶT NGÀY GẦN HẾT HẠN BẢO HIỂM',
    QUAN_LY_BAO_HIEM: 'QUẢN LÝ BẢO HIỂM',
    DUYET_DON_HANG_BAO_HIEM: 'DUYỆT ĐƠN HÀNG BẢO HIỂM',
  },
  SECRETARY_ROLES: {
    QUAN_LY_KE_TOAN: 'QUẢN LÝ KẾ TOÁN',
    QUYEN_DUYET_CHI_TIEN_GDDA: 'QUYỀN DUYỆT CHI TIỀN ( GDDA )',
    QUYEN_DUYET_CHI_TIEN_TPKD: 'QUYỀN DUYỆT CHI TIỀN ( TPKD )',
    QUYEN_DUYET_CHI_TIEN_KTT: 'QUYỀN DUYỆT CHI TIỀN ( KTT )',
    QUYEN_DUYET_CHI_TIEN_KTNB: 'QUYỀN DUYỆT CHI TIỀN ( KTNB )',
  },
  REGULATION_ROLES_2: {
    KHOA_THANH_TOAN_DON_HANG: 'KHOÁ THANH TOÁN ĐƠN HÀNG',
    MO_KHOA_DON_HANG_QUA_HAN_TT: 'MỞ KHÓA ĐƠN HÀNG QUÁ HẠN THANH TOÁN',
    QUAN_LY_PHAP_CHE: 'QUẢN LÝ PHÁP CHẾ',
    QUYEN_DUYET_VI_PHAM_PPPC: 'QUYỀN DUYỆT VI PHẠM ( PPPC )',
    QUYEN_DUYET_VI_PHAM_PPKD: 'QUYỀN DUYỆT VI PHẠM ( PPKD )',
    QUYEN_DUYET_VI_PHAM_TPKD: 'QUYỀN DUYỆT VI PHẠM ( TPKD )',
    QUYEN_DUYET_VI_PHAM_GDDA: 'QUYỀN DUYỆT VI PHẠM ( GDDA )',
  },
  SALARY_ROLES_2: {
    DUYET_GIO_LAM_VIEC: 'DUYỆT GIỜ LÀM VIỆC',
    XEM_BAO_CAO_GIO_VA_NGHI_PHEP: 'XEM BÁO CÁO GIỜ VÀ NGHỈ PHÉP',
    XEM_BANG_CHAM_CONG: 'XEM BẢNG CHẤM CÔNG',
    XEM_KPI_NHAN_HANG: 'XEM KPI NHẬN HÀNG',
    XEM_KPI_VAN_HANH: 'XEM KPI VẬN HÀNH',
    XEM_BANG_LUONG: 'XEM BẢNG LƯƠNG',
    CHINH_SUA_BANG_LUONG: 'CHỈNH SỬA BẢNG LƯƠNG',
    CAI_DAT_LICH_LAM_VIEC: 'CÀI ĐẶT LỊCH LÀM VIỆC',
  },
  PAYMENT_ROLES: {
    QUAN_LY_THANH_TOAN_1: 'QUẢN LÝ THANH TOÁN 1',
    QUAN_LY_THANH_TOAN_2: 'QUẢN LÝ THANH TOÁN 2',
    QUAN_LY_THANH_TOAN_3: 'QUẢN LÝ THANH TOÁN 3',
    QUAN_LY_THANH_TOAN_4: 'QUẢN LÝ THANH TOÁN 4',
    NHAN_TIEN_CHU_HANG_THANH_TOAN: 'NHẬN TIỀN CHỦ HÀNG THANH TOÁN',
    NHAN_VIEN_THUC_HIEN_NHAN_TIEN: 'NHÂN VIÊN THỰC HIỆN NHẬN TIỀN',
    HUY_LENH_NHAN_TIEN: 'HỦY LỆNH NHẬN TIỀN',
    TAI_KHOAN_NHAN_TIEN_THANH_TOAN: 'TÀI KHOẢN NHẬN TIỀN THANH TOÁN',
    KIEM_SOAT_THANH_TOAN_CT_PDV_XEM: 'KIỂM SOÁT THANH TOÁN ĐH CT-PDV - XEM',
    KIEM_SOAT_THANH_TOAN_CT_PDV_DUYET: 'KIỂM SOÁT THANH TOÁN ĐH CT-PDV - DUYỆT',
  },
  COLLATERAL_ROLES: {
    PHO_PHONG_KINH_DOANH: 'PHÓ PHÒNG KINH DOANH',
    TRUONG_PHONG_KINH_DOANH: 'TRƯỞNG PHÒNG KINH DOANH',
    KE_TOAN: 'KẾ TOÁN',
  },
  KIEM_SOAT_DON_ROLES: {
    GHIM_DON_TRA_SOAT: 'GHIM ĐƠN TRA SOÁT',
    AN_DON_HUY_TRA_SOAT: 'ẨN ĐƠN HỦY TRA SOÁT',
    QUAN_LY_DUYET_AN_DON_2: 'QUẢN LÝ DUYỆT ẨN ĐƠN 2',
    QUAN_LY_DUYET_AN_DON_3: 'QUẢN LÝ DUYỆT ẨN ĐƠN 3',
  },
  // 4 loại PHỤ LỤC HỢP ĐỒNG KINH TẾ. `loai` phải trùng TỪNG KÝ TỰ với
  // LOAI_PHU_LUC_HDKT ở backend/src/utils/constant.js và LoaiPhuLucHdkt ở
  // vicchat/lib/core/constants/constants.dart. `images`/`files` là tên cột jsonb trên
  // hop_dong_kinh_te — khai một chỗ rồi map ra nút, khỏi if/else 4 nhánh. `ma` là đoạn mã
  // loại trong ma_hdkt của BẢN PL (<GỐC>_<ma>_<stt>), trùng LOAI_PHU_LUC_HDKT[].ma backend.
  PHU_LUC_HDKT_ITEMS: [
    {
      nhan: 'PL ĐỊA CHỈ',
      loai: 'PHỤ LỤC ĐỊA CHỈ',
      ma: 'PL_DIA_CHI',
      images: 'pl_dia_chi_images',
      files: 'pl_dia_chi_files',
    },
    {
      nhan: 'PL CHỨC VỤ',
      loai: 'PHỤ LỤC CHỨC VỤ',
      ma: 'PL_CHUC_VU',
      images: 'pl_chuc_vu_images',
      files: 'pl_chuc_vu_files',
    },
    {
      nhan: 'PL THAY NGÂN HÀNG',
      loai: 'PHỤ LỤC THAY NGÂN HÀNG',
      ma: 'PL_THAY_NGAN_HANG',
      images: 'pl_thay_ngan_hang_images',
      files: 'pl_thay_ngan_hang_files',
    },
    {
      nhan: 'PL GH NGÀY THANH TOÁN',
      loai: 'PHỤ LỤC GIA HẠN NGÀY THANH TOÁN',
      ma: 'PL_GH_NGAY_THANH_TOAN',
      images: 'pl_gh_ngay_thanh_toan_images',
      files: 'pl_gh_ngay_thanh_toan_files',
    },
  ],
  // Trạng thái BẢN PL — trùng TRANG_THAI_BAN_PL backend (ke-toan-chung-tu.service.js).
  TRANG_THAI_BAN_PL: {
    CHO_XAC_NHAN: 'CHỜ XÁC NHẬN',
    DANG_AP_DUNG: 'ĐANG ÁP DỤNG',
    DA_THAY_THE: 'ĐÃ THAY THẾ',
  },
  KE_TOAN_CHUNG_TU_ROLES: {
    XEM_HOP_DONG_KINH_TE: 'XEM HỢP ĐỒNG KINH TẾ',
    XEM_XUAT_HOA_DON: 'XEM XUẤT HÓA ĐƠN',
    XEM_KIEM_SOAT_HOA_DON: 'XEM KIỂM SOÁT HÓA ĐƠN',
    XEM_BAO_CAO_THONG_KE: 'XEM BÁO CÁO THỐNG KÊ',
    XEM_GIAI_TRINH_THUE: 'XEM GIẢI TRÌNH THUẾ',
    XEM_DOANH_SO: 'XEM DOANH SỐ',
    NHAP_THONG_TIN_HDKT: 'NHẬP THÔNG TIN HỢP ĐỒNG KINH TẾ',
    CHINH_SUA_HDKT: 'CHỈNH SỬA HỢP ĐỒNG KINH TẾ',
    TAI_LEN_HDKT: 'TẢI LÊN HỢP ĐỒNG KINH TẾ',
    // Bốn nút PHỤ LỤC trên bảng HỢP ĐỒNG KINH TẾ. Bên web chúng chỉ xét người tạo /
    // ADMIN1 nên không dùng cờ này; app desktop thì gác thêm, vì ở đó các nút vốn
    // chỉ mở theo ma trận TTCK — ai không nằm trong sáu vai trò được seed thì mất
    // hẳn nút và không có cách nào cấp riêng. Có mặt ở đây để QUẢN LÝ TÀI KHOẢN cấp được.
    TAI_LEN_PHU_LUC_HDKT: 'TẢI LÊN PHỤ LỤC HỢP ĐỒNG',
    NHAP_NOI_DUNG_HOA_DON: 'NHẬP NỘI DUNG HÓA ĐƠN',
    CHINH_SUA_HOA_DON: 'CHỈNH SỬA NỘI DUNG HÓA ĐƠN',
    XEM_HO_SO_HOP_DONG: 'XEM HỒ SƠ HỢP ĐỒNG',
    RESET_DUYET_CTKH: 'RESET DUYỆT CTKH',
    RESET_DUYET_CTCX: 'RESET DUYỆT CTCX',
    TRA_CUU_HOA_DON: 'TRA CỨU HÓA ĐƠN',
    QUET_VA_SO_SANH_TAI_LIEU: 'QUÉT VÀ SO SÁNH TÀI LIỆU',
    // Hai tab LỊCH SỬ mới của KẾ TOÁN CHỨNG TỪ — xem
    // `vic-desktop-app/prompts/22-tra-cuu-hoa-don.md` §5.
    XEM_LENH_TRA_CUU: 'XEM LỆNH TRA CỨU HỒ SƠ HỢP ĐỒNG',
    XEM_SO_SANH_SCAN: 'XEM SO SÁNH SCAN HỒ SƠ HỢP ĐỒNG',
  },
  DANH_GIA_VIC_AI_ROLES: {
    DANH_GIA_VIC_AI_DANG_XU_LY: 'ĐÁNH GIÁ VIC AI - ĐANG XỬ LÝ',
    DANH_GIA_VIC_AI_DANG_XU_LY_TAI_EXCEL: 'ĐÁNH GIÁ VIC AI - ĐANG XỬ LÝ - TẢI EXCEL',
    DANH_GIA_VIC_AI_DA_XU_LY: 'ĐÁNH GIÁ VIC AI - ĐÃ XỬ LÝ',
    DANH_GIA_VIC_AI_DA_XU_LY_TAI_EXCEL: 'ĐÁNH GIÁ VIC AI - ĐÃ XỬ LÝ - TẢI EXCEL',
    DANH_GIA_VIC_AI_THAO_TAC_NUT_DA_XU_LY: 'ĐÁNH GIÁ VIC AI - THAO TÁC NÚT ĐÃ XỬ LÝ',
  },
  LICH_LAM_VIEC_ROLES: {
    GIOI_HAN_GIO_LAM_VIEC: 'GIỚI HẠN GIỜ LÀM VIỆC',
    LICH_NGHI_LE: 'LỊCH NGHỈ LỄ',
    CAI_DAT_LICH_LAM_VIEC: 'CÀI ĐẶT LỊCH LÀM VIỆC',
    LICH_LAM_VIEC_NHAN_VIEN: 'LỊCH LÀM VIỆC NHÂN VIÊN',
    LICH_LAM_VIEC_QUAN_LY: 'LỊCH LÀM VIỆC QUẢN LÝ',
    TONG_HOP_NGHI_PHEP: 'TỔNG HỢP NGHỈ PHÉP',
    DUYET_NGHI_PHEP: 'DUYỆT NGHỈ PHÉP',
  },
  BANK_STATISTIC_ROLES: {
    XEM_SO_DU_NGAN_HANG: 'XEM SỐ DƯ NGÂN HÀNG',
    XEM_THANH_TOAN_HOAN_THANH_DON: 'XEM THANH TOÁN HOÀN THÀNH ĐƠN',
  },
  APP_PERMISSION_ROLES: {
    XEM_DANH_BA: 'XEM DANH BẠ',
    DON_HANG_NHANH: 'ĐƠN HÀNG NHANH',
  },
  PHAN_LOAI_NHOM_NGANH_ROLES: {
    TAO_NGANH_CHINH: 'TẠO NHÓM NGÀNH CHÍNH',
    TAO_NHOM: 'TẠO NHÓM',
    PHAN_NHO_NHOM_NGANH: 'PHÂN NHỎ NHÓM NGÀNH',
    PHAN_VIEC_NHAN_VIEN: 'PHÂN VIỆC NHÂN VIÊN',
    GAN_LINK: 'GẮN LINK',
  },
  EXECUTE_PLAN_ADMIN_ROLES: {
    BANG_CAP_QUYEN: 'BẢNG CẤP QUYỀN',
    CAI_DAT_QUAN_LY: 'CÀI ĐẶT QUẢN LÝ',
  },
  EXECUTE_PLAN_ROLES: {
    CHECKLIST_XEM: 'XEM_CHECKLIST',
    CHECKLIST_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_CHECKLIST',
    CHECKLIST_TAO_TASK: 'TẠO TASK_CHECKLIST',
    CHECKLIST_TAO_HANG_MUC: 'TẠO HẠNG MỤC_CHECKLIST',
    CHECKLIST_CHINH_SUA: 'CHỈNH SỬA_CHECKLIST',
    CHECKLIST_XOA_TASK: 'XÓA TASK_CHECKLIST',
    CHECKLIST_XOA_HANG_MUC: 'XÓA HẠNG MỤC_CHECKLIST',
    DEV_IT_XEM: 'XEM_DEV IT',
    DEV_IT_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_DEV IT',
    DEV_IT_TAO_TASK: 'TẠO TASK_DEV IT',
    DEV_IT_TAO_HANG_MUC: 'TẠO HẠNG MỤC_DEV IT',
    DEV_IT_CHINH_SUA: 'CHỈNH SỬA_DEV IT',
    DEV_IT_XOA_TASK: 'XÓA TASK_DEV IT',
    DEV_IT_XOA_HANG_MUC: 'XÓA HẠNG MỤC_DEV IT',
    DEV_AI_XEM: 'XEM_DEV AI',
    DEV_AI_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_DEV AI',
    DEV_AI_TAO_TASK: 'TẠO TASK_DEV AI',
    DEV_AI_TAO_HANG_MUC: 'TẠO HẠNG MỤC_DEV AI',
    DEV_AI_CHINH_SUA: 'CHỈNH SỬA_DEV AI',
    DEV_AI_XOA_TASK: 'XÓA TASK_DEV AI',
    DEV_AI_XOA_HANG_MUC: 'XÓA HẠNG MỤC_DEV AI',
    MARKETING_XEM: 'XEM_MARKETING',
    MARKETING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_MARKETING',
    MARKETING_TAO_TASK: 'TẠO TASK_MARKETING',
    MARKETING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_MARKETING',
    MARKETING_CHINH_SUA: 'CHỈNH SỬA_MARKETING',
    MARKETING_XOA_TASK: 'XÓA TASK_MARKETING',
    MARKETING_XOA_HANG_MUC: 'XÓA HẠNG MỤC_MARKETING',
    QUAN_LY_XEM: 'XEM_QUẢN LÝ',
    QUAN_LY_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_QUẢN LÝ',
    QUAN_LY_TAO_TASK: 'TẠO TASK_QUẢN LÝ',
    QUAN_LY_TAO_HANG_MUC: 'TẠO HẠNG MỤC_QUẢN LÝ',
    QUAN_LY_CHINH_SUA: 'CHỈNH SỬA_QUẢN LÝ',
    QUAN_LY_XOA_TASK: 'XÓA TASK_QUẢN LÝ',
    QUAN_LY_XOA_HANG_MUC: 'XÓA HẠNG MỤC_QUẢN LÝ',
    TRANSPORT_XEM: 'XEM_TRANSPORT',
    TRANSPORT_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRANSPORT',
    TRANSPORT_TAO_TASK: 'TẠO TASK_TRANSPORT',
    TRANSPORT_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRANSPORT',
    TRANSPORT_CHINH_SUA: 'CHỈNH SỬA_TRANSPORT',
    TRANSPORT_XOA_TASK: 'XÓA TASK_TRANSPORT',
    TRANSPORT_XOA_HANG_MUC: 'XÓA HẠNG MỤC_TRANSPORT',
    TRUCKING_XEM: 'XEM_TRUCKING',
    TRUCKING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRUCKING',
    TRUCKING_TAO_TASK: 'TẠO TASK_TRUCKING',
    TRUCKING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRUCKING',
    TRUCKING_CHINH_SUA: 'CHỈNH SỬA_TRUCKING',
    TRUCKING_XOA_TASK: 'XÓA TASK_TRUCKING',
    TRUCKING_XOA_HANG_MUC: 'XÓA HẠNG MỤC_TRUCKING',
    TRUCKER_XEM: 'XEM_TRUCKER',
    TRUCKER_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRUCKER',
    TRUCKER_TAO_TASK: 'TẠO TASK_TRUCKER',
    TRUCKER_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRUCKER',
    TRUCKER_CHINH_SUA: 'CHỈNH SỬA_TRUCKER',
    TRUCKER_XOA_TASK: 'XÓA TASK_TRUCKER',
    TRUCKER_XOA_HANG_MUC: 'XÓA HẠNG MỤC_TRUCKER',
    SHIPPING_XEM: 'XEM_SHIPPING',
    SHIPPING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_SHIPPING',
    SHIPPING_TAO_TASK: 'TẠO TASK_SHIPPING',
    SHIPPING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_SHIPPING',
    SHIPPING_CHINH_SUA: 'CHỈNH SỬA_SHIPPING',
    SHIPPING_XOA_TASK: 'XÓA TASK_SHIPPING',
    SHIPPING_XOA_HANG_MUC: 'XÓA HẠNG MỤC_SHIPPING',
    HANG_GHEP_XEM: 'XEM_HÀNG GHÉP',
    HANG_GHEP_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_HÀNG GHÉP',
    HANG_GHEP_TAO_TASK: 'TẠO TASK_HÀNG GHÉP',
    HANG_GHEP_TAO_HANG_MUC: 'TẠO HẠNG MỤC_HÀNG GHÉP',
    HANG_GHEP_CHINH_SUA: 'CHỈNH SỬA_HÀNG GHÉP',
    HANG_GHEP_XOA_TASK: 'XÓA TASK_HÀNG GHÉP',
    HANG_GHEP_XOA_HANG_MUC: 'XÓA HẠNG MỤC_HÀNG GHÉP',
    CTV_XEM: 'XEM_CTV',
    CTV_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_CTV',
    CTV_TAO_TASK: 'TẠO TASK_CTV',
    CTV_TAO_HANG_MUC: 'TẠO HẠNG MỤC_CTV',
    CTV_CHINH_SUA: 'CHỈNH SỬA_CTV',
    CTV_XOA_TASK: 'XÓA TASK_CTV',
    CTV_XOA_HANG_MUC: 'XÓA HẠNG MỤC_CTV',
    PHAP_CHE_XEM: 'XEM_PHÁP CHẾ',
    PHAP_CHE_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_PHÁP CHẾ',
    PHAP_CHE_TAO_TASK: 'TẠO TASK_PHÁP CHẾ',
    PHAP_CHE_TAO_HANG_MUC: 'TẠO HẠNG MỤC_PHÁP CHẾ',
    PHAP_CHE_CHINH_SUA: 'CHỈNH SỬA_PHÁP CHẾ',
    PHAP_CHE_XOA_TASK: 'XÓA TASK_PHÁP CHẾ',
    PHAP_CHE_XOA_HANG_MUC: 'XÓA HẠNG MỤC_PHÁP CHẾ',
    KE_TOAN_XEM: 'XEM_KẾ TOÁN',
    KE_TOAN_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_KẾ TOÁN',
    KE_TOAN_TAO_TASK: 'TẠO TASK_KẾ TOÁN',
    KE_TOAN_TAO_HANG_MUC: 'TẠO HẠNG MỤC_KẾ TOÁN',
    KE_TOAN_CHINH_SUA: 'CHỈNH SỬA_KẾ TOÁN',
    KE_TOAN_XOA_TASK: 'XÓA TASK_KẾ TOÁN',
    KE_TOAN_XOA_HANG_MUC: 'XÓA HẠNG MỤC_KẾ TOÁN',
  },
  SALARY_ROLES: {
    1: 'DUYỆT GIỜ LÀM VIỆC',
    2: 'XEM BÁO CÁO GIỜ VÀ NGHỈ PHÉP',
    3: 'XEM BẢNG CHẤM CÔNG',
    4: 'XEM KPI NHẬN HÀNG',
    5: 'XEM KPI VẬN HÀNH',
    6: 'XEM BẢNG LƯƠNG',
    7: 'CHỈNH SỬA BẢNG LƯƠNG',
  },
  REGULATION_ROLES: {
    1: 'PPPC',
    2: 'PPKD',
    3: 'TPKD',
    4: 'GDDA',
  },
  PROJECTS: {
    PHAN_MEM_VIC: 'PHẦN MỀM VIC',
    PROJECT_ONE: 'PROJECT ONE',
  },
  // Tên chức vụ (users.position) dùng làm quy tắc nghiệp vụ cứng — khớp backend CONSTANT.CHUC_VU
  CHUC_VU: {
    KE_TOAN_KIEM_SOAT: 'KẾ TOÁN KIỂM SOÁT',
  },
  VIC_MENU_OPTIONS: {
    DS_TAI_XE: 'DS TÀI XẾ',
    XE_DAT_HANG: 'XE ĐẶT HÀNG',
    DS_CHANH: 'DS CHÀNH',
    CHANH_DAT_HANG: 'CHÀNH ĐẶT HÀNG',
    DS_CHU_HANG: 'DS CHỦ HÀNG',
    CHU_DAT_HANG: 'CHỦ ĐẶT HÀNG',
    VAN_HANH_DON_HANG: 'VẬN HÀNH ĐƠN HÀNG',
    VAN_HANH_DON_HANG_PHONG_THAU: 'VẬN HÀNH ĐƠN HÀNG - PHÒNG THẦU',
    DANH_SACH_VAY_TIEN: 'DS VAY TIỀN',
    HAN_MUC_CONG_NO: 'HẠN MỨC CÔNG NỢ',
    HOP_DONG_DON_HANG: 'HỢP ĐỒNG ĐƠN HÀNG',
    KE_TOAN_CHUNG_TU: 'KẾ TOÁN CHỨNG TỪ',
    THANH_TOAN_CHUYEN_KHOAN: 'THANH TOÁN CHUYỂN KHOẢN',
    KIEM_SOAT_DON_HANG: 'KIỂM SOÁT ĐƠN HÀNG',
    THAM_KHAO_GIA: 'THAM KHẢO GIÁ',
    DON_HANG_NHANH: 'ĐƠN HÀNG NHANH',
    DON_HANG_NHANH_TEST: 'ĐƠN HÀNG NHANH TEST',
    XE_TIM_HANG: 'XE TÌM HÀNG',
    KY_QUY: 'KÝ QUỸ',
    DS_BAO_HIEM: 'DS BẢO HIỂM',
    CSKH_BAO_HIEM: 'CSKH BẢO HIỂM',
    DON_HANG_BAO_HIEM: 'ĐƠN HÀNG BẢO HIỂM',
    // Trang cũ /phan-viec-chu-hang. GIÁ TRỊ giữ nguyên (đã lưu trong users.vic_menus); chữ hiển thị là
    // 'PHÂN VIỆC KHÁCH HÀNG (CŨ)' — xem VIC_MENU_LABELS bên dưới.
    PHAN_VIEC_CHU_HANG: 'PHÂN VIỆC CHỦ HÀNG',
    // Chuỗi này PHẢI trùng WEB_MENU_PHAN_VIEC_KHACH_HANG ở backend/src/services/permission/vic-app-menu.service.js.
    PHAN_VIEC_KHACH_HANG: 'PHÂN VIỆC KHÁCH HÀNG',
    // Trang PHÂN VIỆC TÀI XẾ MỚI (/phan-viec-tai-xe, bot trợ lý AI). PHẢI trùng WEB_MENU_PHAN_VIEC_TAI_XE ở
    // backend vic-app-menu.service.js và chat/src/utils/tro-ly-ai.js. Khác PPKD_ROLES.PHAN_VIEC_TAI_XE
    // (vai trò cùng chữ, cột system_roles, gác trang cũ /phan-viec-tai-xe-cu).
    PHAN_VIEC_TAI_XE_MOI: 'PHÂN VIỆC TÀI XẾ',
    TH_GIAN_LAM_VIEC: 'TH/GIAN LÀM VIỆC',
    TARGET_DOANH_SO: 'TARGET DOANH SỐ',
    CHAT: 'CHAT',
    QUAN_LY_FILE: 'QUẢN LÝ FILE',
    BAO_CAO_THONG_KE_CONG_VIEC: 'BÁO CÁO THỐNG KÊ CÔNG VIỆC',
    PHAP_CHE: 'PHÁP CHẾ',
    EXECUTE_THE_PLAN: 'EXECUTE THE PLAN',
    LANDING_PAGE: 'LANDING PAGE',
    NGANH_HANG_PHU_TRO: 'NGÀNH HÀNG PHỤ TRỢ',
    DANH_GIA_VIC_AI: 'ĐÁNH GIÁ VIC AI',
    KHAO_SAT: 'KHẢO SÁT',
    QUAN_LY_TAI_XE: 'QUẢN LÝ XE',
    LICH_LAM_VIEC: 'LỊCH LÀM VIỆC',
    XU_LY_VAN_BAN: 'XỬ LÝ VĂN BẢN',
    CAI_DAT_KHEN_THUONG: 'CÀI ĐẶT KHEN THƯỞNG',
    THEO_DOI_HE_THONG: 'THEO DÕI HỆ THỐNG',
    THEO_DOI_AI_SERVER: 'THEO DÕI AI SERVER',
    // Kế hoạch 7 (22/10/2026). PHẢI trùng WEB_MENU_LICH_BOT_CHAY / WEB_MENU_VAN_PHONG_3D ở
    // backend/src/services/permission/vic-app-menu.service.js (cổng /tro-ly-ai/lich-bot*, /van-phong*; không bypass quản trị).
    LICH_BOT_CHAY: 'LỊCH BOT CHẠY',
    VAN_PHONG_3D: 'VĂN PHÒNG 3D',
    // Chuỗi này PHẢI trùng VIC_MENU_HANG_MUC_AI ở backend/src/routes/hang-muc-ai.controller.js.
    HANG_MUC_AI: 'HẠNG MỤC AI',
  },
  // Chữ HIỂN THỊ của menu web khác giá trị lưu (đổi tên mà không mất quyền đã cấp). Không có trong bảng = hiện y giá trị.
  VIC_MENU_LABELS: {
    'PHÂN VIỆC CHỦ HÀNG': 'PHÂN VIỆC KHÁCH HÀNG (CŨ)',
  } as Record<string, string>,
  // Chữ HIỂN THỊ của vai trò quản trị (PPKD_ROLES) khác giá trị lưu — bản chốt mã quyền 28/10/2026: hai vai trò của trang
  // phân việc cũ thêm "(CŨ)", chuỗi lưu trong users.*_roles GIỮ NGUYÊN (backend/hasRole vẫn so chuỗi cũ).
  ROLE_LABELS: {
    'PHÂN VIỆC TÀI XẾ': 'PHÂN VIỆC TÀI XẾ (CŨ)',
    'PHÂN VIỆC CHỦ HÀNG': 'PHÂN VIỆC CHỦ HÀNG (CŨ)',
  } as Record<string, string>,
  PO_MENU_OPTIONS: {
    DS_TAI_XE: 'DS TÀI XẾ',
    DAT_DON_CHO_TX: 'ĐẶT ĐƠN CHO TX',
    LICH_TRINH_TX: 'LỊCH TRÌNH TX',
    DS_KHACH_HANG: 'DS KHÁCH HÀNG',
    DAT_DON_CHO_KH: 'ĐẶT ĐƠN CHO KH',
    VAN_HANH_DON: 'VẬN HÀNH ĐƠN',
  },
  PO_TAI_XE_ROLES: {
    THEM_TAI_XE: 'THÊM TÀI XẾ',
    CHINH_SUA_THONG_TIN_TX: 'CHỈNH SỬA THÔNG TIN TÀI XẾ',
    NGHI_VIEC_TX: 'NGHỈ VIỆC TX',
    NGHI_PHEP_TX: 'NGHỈ PHÉP TX',
  },
  PO_DON_HANG_TAI_XE_ROLES: {
    TXE_HUY_DON: 'HỦY ĐƠN TÀI XẾ',
  },
  PO_LICH_TRINH_TAI_XE_ROLES: {
    DAT_DON_HANG_TAI_XE: 'ĐẶT ĐƠN HÀNG TÀI XẾ',
    CHINH_SUA_LICH_TRINH: 'CHỈNH SỬA LỊCH TRÌNH',
    CAI_DAT_GIA_GOC: 'CÀI ĐẶT GIÁ GỐC',
    CAI_DAT_GIA_KHUYEN_MAI: 'CÀI ĐẶT GIÁ KHUYẾN MÃI',
    XEM_LICH_SU_GIA_KHUYEN_MAI: 'XEM LỊCH SỬ GIÁ KHUYẾN MÃI',
  },
  PO_KHACH_HANG_ROLES: {
    DAT_DON_HANG_KHACH_HANG: 'ĐẶT ĐƠN HÀNG KHÁCH HÀNG',
  },
  PO_DON_HANG_KH_ROLES: {
    HUY_DON_KHACH_HANG: 'HỦY ĐƠN KHÁCH HÀNG',
    CHINH_SUA_DON_HANG: 'CHỈNH SỬA ĐƠN HÀNG',
    VAN_HANH_DON_HANG: 'VẬN HÀNH ĐƠN HÀNG',
  },
  PO_VAN_HANH_DON_ROLES: {
    HUY_DON_VAN_HANH: 'HỦY ĐƠN VẬN HÀNH',
    CHECK_IN: 'CHECK IN',
    CHECK_OUT: 'CHECK OUT',
  },
  SOCKET_EVENT: {
    MESSAGE_COUNT: 'message-count',
    NEW_MESSAGE: 'new-message',
    // NEW_INSTANT: 'new-instant',
    NEW_INSTANT_V2: 'new-instant-v2',
    NEW_INSTANT_OWNER: 'new-instant-owner',
    NEW_OWNER_ASSIGNMENT: 'new-owner-assignment',
    NEW_MATCHING_OWNER: 'new-matching-owner',
    NEW_MATCHING_ORDER: 'new-matching-order',
    NEW_PRICE_QUOTE: 'new-price-quotes',
    NEW_ORDER: 'new-order',
    INSTANT_RESERVE: 'instant-reserve',
    UPDATE_INSTANT_OWNER: 'update-instant-owner',
    UPDATE_SUGGESTION: 'update-suggestion',
    UPDATE_MESSAGE: 'update-message',
    UPDATE_XUAT_HOA_DON: 'update-xuat-hoa-don',
    // Bộ đếm chưa đọc của CHÍNH mình vừa đổi ở tab/thiết bị khác. Phải khớp
    // SOCKET_EVENTS.UNREAD_UPDATED ở chat/src/utils/constant.js và
    // SOCKET_EVENT.UNREAD_UPDATED ở webchat/src/utils/constant.ts.
    UNREAD_UPDATED: 'unread-updated',
  },
  LOCATION_DURATION: 3,
  RESERVED_TIME: 10,
  LOCKED_TIME_FOR_GROUP: 5,
  LOCKED_FOR_PRICE_QUOTE: 15,
  // LOCKED_FOR_PRICE_QUOTE: 1,
  PAYMENT_TYPE: {
    CONG_TY: 'CÔNG TY',
    CONG_TY_THU_HO: 'CÔNG TY - THU HỘ',
    CONG_TY_PHI_DICH_VU: 'CÔNG TY - PHÍ DỊCH VỤ',
    THU_HO: 'THU HỘ',
    PHI_DICH_VU: 'PHÍ DỊCH VỤ',
  },
  COMPANY_PAYMENTS: ['CÔNG TY', 'CÔNG TY - THU HỘ', 'CÔNG TY - PHÍ DỊCH VỤ'],
  COMPANY_PAYMENTS_WITH_VAT: ['CÔNG TY', 'CÔNG TY - THU HỘ'],
  // Dropdown THỰC HIỆN LỆNH CHUYỂN TIỀN (đơn PHÍ DỊCH VỤ / CÔNG TY - PHÍ DỊCH VỤ) — prompts/10-payment-without-transfer.md
  THUC_HIEN_LENH_CHUYEN_TIEN: {
    VIC_CHUYEN: 'VIC CHUYỂN TIỀN DỊCH VỤ',
    KHONG_CHUYEN: 'KHÔNG CHUYỂN DỊCH VỤ',
  },
  // Các loại khoản (payments.type) được chọn KHÔNG CHUYỂN DỊCH VỤ
  KHONG_CHUYEN_DICH_VU_TYPES: [
    'phi_dv_hh',
    'phi_dv_hh_2',
    'phi_dv_cho_xe',
    'phi_dv_cho_xe_2',
    'phat_sinh_den_bu',
    'vic_back_khach_hang',
    'ctv_sm_kpi',
    'ctv_f1_kpi',
    'ctv_f2_kpi',
  ],
  OWNER_STATUS: {
    CHO_XAC_MINH: 'CHỜ XÁC MINH',
    VAN_HANH_NGAY: 'VẬN HÀNH NGAY',
  },
  CUSTOMER_POSITION: {
    CTV: 'Cộng tác viên',
  },
  MANAGED_USER_ROLES: {
    XEM_CHI_TIET_BAO_GIA_DON_HANG: 'XEM CHI TIẾT BÁO GIÁ ĐƠN HÀNG',
    THANH_TOAN_CHUYEN_KHOAN: 'THANH TOÁN CHUYỂN KHOẢN',
    DUYET_NHAN_TIEN: 'DUYỆT NHẬN TIỀN CHO NHÂN VIÊN NHẬN HÀNG',
    DANH_SACH_TAI_XE: 'DANH SÁCH TÀI XẾ',
    DANH_SACH_LUU_TRU_TAI_XE: 'DANH SÁCH LƯU TRỮ TÀI XẾ',
    HOP_DONG_KINH_TE: 'HỢP ĐỒNG KINH TẾ',
    XUAT_HOA_DON: 'XUẤT HÓA ĐƠN',
    DUYET_HOA_DON: 'DUYỆT - HÓA ĐƠN',
    DUYET_KT_XUAT_HOA_DON: 'DUYỆT - KT XUẤT HÓA ĐƠN',
    LICH_LAM_VIEC_NHAN_VIEN: 'LỊCH LÀM VIỆC - LỊCH LÀM VIỆC NHÂN VIÊN',
  },
  HINH_THUC_CONG_NO: {
    KHONG_CONG_NO: 'KHÔNG CÔNG NỢ',
    CN_KHONG_BAO_LANH: 'CÔNG NỢ KHÔNG BẢO LÃNH',
    CN_BAO_LANH: 'CÔNG NỢ CÔNG TY CÓ BẢO LÃNH',
  },
  LOAI_CN_BAO_LANH: {
    THANH_TOAN_NGAY: 'THANH TOÁN NGAY',
    XE_HD_CNG_NO_VIC: 'XE HỢP ĐỒNG CÔNG NỢ VỚI VIC',
  },
  EXECUTE_PLAN_GROUP: {
    CHECKLIST: 'CHECKLIST',
    DEV_IT: 'DEV_IT',
    DEV_AI: 'DEV_AI',
    MARKETING: 'MARKETING',
    QUAN_LY: 'QUAN_LY',
    TRANSPORT: 'TRANSPORT',
    TRUCKING: 'TRUCKING',
    TRUCKER: 'TRUCKER',
    SHIPPING: 'SHIPPING',
    HANG_GHEP: 'HANG_GHEP',
    CTV: 'CTV',
    PHAP_CHE: 'PHAP_CHE',
    KE_TOAN: 'KE_TOAN',
  },
  // Các nhóm dùng thêm cột HỆ THỐNG + LOẠI TASK (trước đây chỉ có IT, nay tách thành DEV IT & DEV AI).
  EXECUTE_PLAN_SYSTEM_GROUPS: ['DEV_IT', 'DEV_AI'],
  WORKING_TYPE_COLOR: {
    working_assigned: {
      label: 'LỊCH ĐI LÀM',
      label_status: 'LỊCH ĐI LÀM',
      color: '#92D050',
      textColor: '#000000',
    },
    working: {
      label: 'CHECK IN - CHECK OUT',
      label_status: 'CHECK IN - CHECK OUT',
      color: '#00B0F0',
      textColor: '#ffffff',
    },
    ot_assigned: {
      label: 'LỊCH TRỰC',
      label_status: 'LỊCH TRỰC',
      color: '#00B050',
      textColor: '#ffffff',
    },
    leave_paid: {
      label: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG (Chưa duyệt)',
      color: '#E2EFDA',
      textColor: '#000000',
    },
    leave_paid_approved: {
      label: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG (Đã duyệt)',
      color: '#548236',
      textColor: '#ffffff',
    },
    leave_paid_rejected: {
      label: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP CÓ LƯƠNG (Từ chối)',
      color: '#FF0000',
      textColor: '#ffffff',
    },
    leave_unpaid: {
      label: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG (Chưa duyệt)',
      color: '#D9E1F2',
      textColor: '#000000',
    },
    leave_unpaid_approved: {
      label: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG (Đã duyệt)',
      color: '#305496',
      textColor: '#ffffff',
    },
    leave_unpaid_rejected: {
      label: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG',
      label_status: 'LỊCH NGHỈ PHÉP KHÔNG LƯƠNG (Từ chối)',
      color: '#FF0000',
      textColor: '#ffffff',
    },
    holiday: {
      label: 'LỊCH NGHỈ LỄ',
      label_status: 'LỊCH NGHỈ LỄ',
      color: '#5B9BD5',
      textColor: '#ffffff',
    },
    outside_personal: {
      label: 'RA NGOÀI VIỆC CÁ NHÂN',
      label_status: 'RA NGOÀI VIỆC CÁ NHÂN (Chưa duyệt)',
      color: '#FCE4D6',
      textColor: '#000000',
    },
    outside_personal_approved: {
      label: 'RA NGOÀI VIỆC CÁ NHÂN',
      label_status: 'RA NGOÀI VIỆC CÁ NHÂN (Đã duyệt)',
      color: '#C65911',
      textColor: '#000000',
    },
    outside_personal_rejected: {
      label: 'RA NGOÀI VIỆC CÁ NHÂN',
      label_status: 'RA NGOÀI VIỆC CÁ NHÂN (Từ chối)',
      color: '#FF0000',
      textColor: '#ffffff',
    },
    outside_company: {
      label: 'RA NGOÀI VIỆC CÔNG TY',
      label_status: 'RA NGOÀI VIỆC CÔNG TY (Chưa duyệt)',
      color: '#FFF2CC',
      textColor: '#000000',
    },
    outside_company_approved: {
      label: 'RA NGOÀI VIỆC CÔNG TY',
      label_status: 'RA NGOÀI VIỆC CÔNG TY (Đã duyệt)',
      color: '#FFD966',
      textColor: '#000000',
    },
    outside_company_rejected: {
      label: 'RA NGOÀI VIỆC CÔNG TY',
      label_status: 'RA NGOÀI VIỆC CÔNG TY (Từ chối)',
      color: '#FF0000',
      textColor: '#ffffff',
    },
    no_working: {
      label: 'KHÔNG LÀM VIỆC',
      label_status: 'KHÔNG LÀM VIỆC',
      color: '#ffff00',
      textColor: '#000000',
    },
  },
};

export default CONSTANTS;
